import styled from 'styled-components';

export const PermissionCardContainer = styled.div`
  .ant-tabs-tab {
    background: transparent !important;
  }

  .permissions-card-divider {
    margin-top: 24px !important;
    margin-bottom: 6px !important;
    .ant-divider-inner-text {
      font-size: 0.7rem;
      opacity: 0.7;
    }
  }

  @media (max-width: 360px) {
    .permissions-card-header {
      .ant-radio-group,
      .ant-checkbox-wrapper {
        margin: 0 auto;
      }
      .ant-checkbox-wrapper {
        margin-top: 8px;
      }
    }
  }
`;
